import React from "react";
import { type ReactFlowEmitter } from "../../emitter/ReactFlowEmitter";

type ReactFlowCanvasContextEventsType = ReactFlowEmitter | undefined;
export const ReactFlowCanvasContextEvents = React.createContext<ReactFlowCanvasContextEventsType>(undefined);

export function useReactFlowCanvasEventEmitter() {
  return React.useContext(ReactFlowCanvasContextEvents);
}
